module.exports = __webpack_public_path__ + "img/867.2e2b249d.png";